import { FC, memo, MouseEvent, ReactNode } from 'react';
import './styles.scss';

const Button: FC<{
  name?: string;
  text?: string;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  className?: string;
  primary?: boolean;
  uppercase?: boolean;
  border?: boolean;
  transparent?: boolean;
  children?: ReactNode;
  type?: 'submit' | 'reset' | 'button';
  hasShadow?: boolean;
  tabIndex?: number;
  id?: string;
}> = ({
  name = '',
  text = '',
  onClick,
  disabled,
  className = '',
  primary,
  uppercase,
  border = false,
  transparent = false,
  children,
  type = 'button',
  hasShadow = true,
  tabIndex,
  id = '',
}) => {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      id={id}
      className={`${className} btn custom-button ${
        primary ? 'primary-btn' : ''
      } ${uppercase ? 'text-uppercase' : ''} ${
        disabled ? 'non-clickable' : ''
      } ${!border ? 'no-border' : 'has-border'} ${
        !transparent ? '' : 'transparent'
      } ${hasShadow ? 'shadow-effect' : ''}`}
      name={name}
      type={type}
      aria-label={text}
      tabIndex={tabIndex}
    >
      {text}
      {children}
    </button>
  );
};

export default memo(Button);
